import { primaryColourMain } from 'app/agriculture/material';

interface BillboardPercentageBarProps {
    percentage: number;
}

export function BillboardPercentageBar({ percentage }: BillboardPercentageBarProps) {
    const height = 140 * (percentage / 100);
    const colour = primaryColourMain;

    const symbol = `
        <symbol id="percentage-bar" viewBox="0 0 40 156">
            <rect x="0" y="0" width="40" height="156" rx="20" ry="20" fill="white" />
            <rect x="4" y="4" width="32" height="148" rx="16" ry="16" fill="${colour}40" stroke="#fff" stroke-width="8"/>
            <rect x="8" y="${148 - height}" width="24" height="${height}" rx="12" ry="12" fill="${colour}" />
        </symbol>
    `;
    const use = `
        <use
            href="#percentage-bar"
            x="320"
            y="112"
            width="40"
            height="156"
        />
    `;

    return symbol + use;
}
